import { render } from "./ShopBills.vue?vue&type=template&id=6fa5501a"
import script from "./ShopBills.vue?vue&type=script&lang=ts"
export * from "./ShopBills.vue?vue&type=script&lang=ts"
script.render = render

export default script